import { render } from "./oficialiaOficios.vue?vue&type=template&id=58da1293&scoped=true"
import script from "./oficialiaOficios.vue?vue&type=script&lang=js"
export * from "./oficialiaOficios.vue?vue&type=script&lang=js"

import "./oficialiaOficios.vue?vue&type=style&index=0&id=58da1293&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58da1293"]])

export default __exports__